import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import avatar from "../../../assets/img/avatar/user-dummy-img.jpg";
import "./sidebar.scss";
import { question } from "../../../helpers/swal";
import { BiChevronLeft } from "react-icons/bi";
import { AiOutlineFileText, AiOutlineSafetyCertificate } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { chevronClicked } from "../../../store/slices/sidebar-slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { logout } from "../../../store/slices/auth-slice";
import { encryptedLocalStorage } from "../../../helpers/functions/encrypt-storage";
import { AiOutlineFile } from "react-icons/ai";
import { AiOutlinePrinter } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { HiOutlineShoppingCart } from "react-icons/hi";
import axios from "axios";
import { settings } from "../../../helpers/settings";
import authHeader from "../../../helpers/functions/auth-header";
import React, { useState, useEffect } from "react";
import { AiOutlineSetting } from "react-icons/ai";
import { FiBox } from "react-icons/fi";
import { AiOutlineBarChart } from "react-icons/ai";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { AiOutlineMessage } from "react-icons/ai";

const Sidebar = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${settings.apiURL}/get_profile.php`, {
          headers: authHeader(),
        });

        if (response.data.success) {
          setProfile(response.data.user);
          localStorage.setItem("user_type", response.data.user.user_type);
        }
      } catch (error) {
        console.error("Sidebar profil bilgisi alınamadı", error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("user_profile");
    if (stored) {
      const userData = JSON.parse(stored);
      setProfile(userData);
      localStorage.setItem("user_type", userData.user_type);
    }
  }, []);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { sidebarLeft } = useAppSelector((state) => state.left);
  const dispatch = useAppDispatch();

  const userEmail = localStorage.getItem("email");
  const userType = localStorage.getItem("user_type");

  // Jiffy kullanıcıları listesi
  const jiffyUsers = [
    "jiffyca@txmaya.com",
    "houstonorders@txmaya.com",
    "dallasorders@txmaya.com",
    "jiffyokc@txmaya.com",
  ];

  const isJiffyUser = jiffyUsers.includes(userEmail);
  const isAdmin = ["admin@txmaya.com", "mhmtmnctl20@gmail.com"].includes(
    userEmail,
  );
  const isAccounting = [
    "fuatsaglam1983@gmail.com",
    "mhmtmnctl20@gmail.com",
  ].includes(userEmail);

  // ✅ YENİ: CA Orders görünürlük kontrolü
  const showCAOrders =
    userEmail === "jiffyca@txmaya.com" || userEmail === "mhmtmnctl20@gmail.com";

  // ✅ YENİ: Houston Orders görünürlük kontrolü
  const showHoustonOrders =
    userEmail === "houstonorders@txmaya.com" ||
    userEmail === "admin@txmaya.com" ||
    userEmail === "mhmtmnctl20@gmail.com";

  // ✅ YENİ: Dallas Orders görünürlük kontrolü
  const showDallasOrders =
    userEmail === "dallasorders@txmaya.com" ||
    userEmail === "mhmtmnctl20@gmail.com";

  // ✅ YENİ: Oklahoma Orders görünürlük kontrolü
  const showOklahomaOrders =
    userEmail === "jiffyokc@txmaya.com" ||
    userEmail === "mhmtmnctl20@gmail.com";

  const showMyTasks = userType === "employee" && !isAdmin;

  const isTxmayaAdmin = userEmail === "admin@txmaya.com";

  useEffect(() => {
    if (isTxmayaAdmin && pathname === "/home") {
      navigate("/houston-orders");
      return;
    }
    if (isJiffyUser && pathname === "/home") {
      if (userEmail === "jiffyca@txmaya.com") {
        navigate("/ca-orders");
      } else if (userEmail === "houstonorders@txmaya.com") {
        navigate("/houston-orders");
      } else if (userEmail === "dallasorders@txmaya.com") {
        navigate("/dallas-orders");
      } else if (userEmail === "jiffyokc@txmaya.com") {
        navigate("/oklahoma-orders");
      }
    }
  }, [userEmail, pathname, navigate, isJiffyUser, isTxmayaAdmin]);

  const handleSidebarToggle = () => {
    dispatch(chevronClicked(!sidebarLeft));
  };

  const handleLogout = () => {
    question("Logout", "Are you sure to logout?").then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        encryptedLocalStorage.removeItem("token");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("user_id");
        localStorage.removeItem("user");
        localStorage.removeItem("user_type");
        sessionStorage.removeItem("googleApisToken");
        navigate("/");
      }
    });
  };

  // Jiffy kullanıcıları için order linkini belirle
  const getOrderLink = () => {
    switch (userEmail) {
      case "jiffyca@txmaya.com":
        return "/ca-orders";
      case "houstonorders@txmaya.com":
        return "/houston-orders";
      case "dallasorders@txmaya.com":
        return "/dallas-orders";
      case "jiffyokc@txmaya.com":
        return "/oklahoma-orders";
      default:
        return "/home";
    }
  };

  // Jiffy kullanıcıları için order başlığını belirle
  const getOrderTitle = () => {
    switch (userEmail) {
      case "jiffyca@txmaya.com":
        return "CA Orders";
      case "houstonorders@txmaya.com":
        return "Houston Orders";
      case "dallasorders@txmaya.com":
        return "Dallas Orders";
      case "jiffyokc@txmaya.com":
        return "Oklahoma Orders";
      default:
        return "Orders";
    }
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      className={sidebarLeft ? "admin-navbar admin-left" : "admin-navbar"}
      variant="dark"
      style={{ height: "100vh", overflowY: "auto", paddingBottom: "80px" }}
    >
      <Container>
        <>
          <div className="avatar">
            <h5>MAYA UP</h5>
            <div className="admin-brand">
              <Navbar.Brand>
                <img
                  src={
                    profile?.profile_image
                      ? `https://mayatxupload.com/mayaUp/uploads/profile_images/${profile.profile_image}`
                      : avatar
                  }
                  alt="avatar"
                  className="img-fluid rounded-circle"
                  style={{ width: "60px", height: "60px", objectFit: "cover" }}
                />
              </Navbar.Brand>
              <p style={{ margin: 0 }}>
                {profile?.first_name} {profile?.last_name}
              </p>
              <p style={{ margin: 0, fontSize: "12px", color: "#6b7280" }}>
                {userType === "employee" ? "👨‍💼 Employee" : "🏪 External Store"}
              </p>

              <Nav.Link
                as={Link}
                to="/profile"
                active={pathname.startsWith("/profile")}
                style={{
                  paddingLeft: "0",
                  fontSize: "13px",
                  color: "#007bff",
                  textDecoration: "underline",
                  marginTop: "4px",
                }}
              >
                Edit Profile
              </Nav.Link>
            </div>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {/* Jiffy kullanıcıları için basit menü */}
              {isJiffyUser ? (
                <>
                  <Nav.Link
                    as={Link}
                    to={getOrderLink()}
                    active={pathname === getOrderLink()}
                  >
                    <AiOutlineMail style={{ marginRight: "8px" }} />
                    {getOrderTitle()}
                  </Nav.Link>
                  {userEmail === "dallasorders@txmaya.com" && (
                    <Nav.Link
                      as={Link}
                      to="/dallas-inventory"
                      active={pathname === "/dallas-inventory"}
                    >
                      <FiBox style={{ marginRight: "8px" }} /> Inventory
                    </Nav.Link>
                  )}
                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              ) : isTxmayaAdmin ? (
                <>
                  <Nav.Link
                    as={Link}
                    to="/houston-orders"
                    active={pathname === "/houston-orders"}
                  >
                    <AiOutlineMail style={{ marginRight: "4px" }} /> Houston
                    Orders
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/admin/jiffy-orders"
                    active={pathname.startsWith("/admin/jiffy-orders")}
                  >
                    <AiOutlineMail style={{ marginRight: "4px" }} /> Jiffy
                    Orders
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/admin/jiffy-reports"
                    active={pathname.startsWith("/admin/jiffy-reports")}
                  >
                    <AiOutlineBarChart style={{ marginRight: "8px" }} /> Jiffy
                    Reports
                  </Nav.Link>
                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              ) : userEmail === "embroidery@txmaya.com" ? (
                <>
                  <Nav.Link
                    as={Link}
                    to="/admin/embroidery-orders"
                    active={pathname.startsWith("/admin/embroidery-orders")}
                  >
                    <AiOutlineMail style={{ marginRight: "8px" }} /> Embroidery
                    Files
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/embroidery-my-orders"
                    active={pathname.startsWith("/embroidery-my-orders")}
                  >
                    <HiOutlineShoppingCart style={{ marginRight: "10px" }} />{" "}
                    Embroidery Orders
                  </Nav.Link>
                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              ) : (
                <>
                  {/* ✅ Riverside Orders */}
                  {showCAOrders && (
                    <Nav.Link
                      as={Link}
                      to="/ca-orders"
                      active={pathname === "/ca-orders"}
                    >
                      <AiOutlineMail style={{ marginRight: "8px" }} />
                      Riverside Orders
                    </Nav.Link>
                  )}

                  {/* ✅ Houston Orders - /admin/ OLMADAN */}
                  {showHoustonOrders && (
                    <Nav.Link
                      as={Link}
                      to="/houston-orders"
                      active={pathname === "/houston-orders"}
                    >
                      <AiOutlineMail style={{ marginRight: "4px" }} /> Houston
                      Orders
                    </Nav.Link>
                  )}

                  {/* ✅ Dallas Orders - /admin/ OLMADAN */}
                  {showDallasOrders && (
                    <>
                      <Nav.Link
                        as={Link}
                        to="/dallas-orders"
                        active={pathname === "/dallas-orders"}
                      >
                        <AiOutlineMail style={{ marginRight: "10px" }} /> Dallas
                        Orders
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        to="/dallas-inventory"
                        active={pathname === "/dallas-inventory"}
                      >
                        <FiBox style={{ marginRight: "10px" }} /> Dallas
                        Inventory
                      </Nav.Link>
                    </>
                  )}

                  {/* ✅ Oklahoma Orders - /admin/ OLMADAN */}
                  {showOklahomaOrders && (
                    <Nav.Link
                      as={Link}
                      to="/oklahoma-orders"
                      active={pathname === "/oklahoma-orders"}
                    >
                      <AiOutlineMail style={{ marginRight: "1px" }} /> Oklahoma
                      Orders
                    </Nav.Link>
                  )}

                  <Nav.Link
                    as={Link}
                    to="/send-files"
                    active={pathname.startsWith("/send-files")}
                  >
                    <AiOutlineCloudUpload style={{ marginRight: "8px" }} /> Send
                    Files
                  </Nav.Link>

                  {![
                    "houstonorders@txmaya.com",
                    "dallasorders@txmaya.com",
                  ].includes(localStorage.getItem("email")) && (
                    <Nav.Link as={Link} to="/my-files">
                      <AiOutlineFile style={{ marginRight: "8px" }} /> My Files
                    </Nav.Link>
                  )}

                  {userEmail !== "admin@txmaya.com" && (
                    <Nav.Link
                      as={Link}
                      to="/my-orders"
                      active={pathname.startsWith("/my-orders")}
                    >
                      <HiOutlineShoppingCart style={{ marginRight: "10px" }} />{" "}
                      My Orders
                    </Nav.Link>
                  )}

                  {/* My Tasks sadece employee'lar için */}
                  {showMyTasks && (
                    <Nav.Link
                      as={Link}
                      to="/my-tasks"
                      active={pathname.startsWith("/my-tasks")}
                    >
                      <AiOutlineCheckSquare style={{ marginRight: "8px" }} /> My
                      Tasks
                    </Nav.Link>
                  )}

                  {!isJiffyUser && userEmail !== "embroidery@txmaya.com" && (
                    <Nav.Link
                      as={Link}
                      to="/tickets"
                      active={pathname.startsWith("/tickets")}
                    >
                      <AiOutlineMessage style={{ marginRight: "8px" }} />
                      My Tickets
                    </Nav.Link>
                  )}

                  <Nav.Link
                    as={Link}
                    to="/inventory"
                    active={pathname.startsWith("/inventory")}
                  >
                    <FiBox style={{ marginRight: "8px" }} /> Inventory
                  </Nav.Link>

                  {isAccounting && (
                    <Nav.Link
                      as={Link}
                      to="/report"
                      active={pathname.startsWith("/report")}
                    >
                      <AiOutlineFileText style={{ marginRight: "-15px" }} />{" "}
                      Accounting Report
                    </Nav.Link>
                  )}

                  {userEmail === "mhmtmnctl20@gmail.com" && (
                    <Nav.Link
                      as={Link}
                      to="/admin/production-stats"
                      active={pathname.startsWith("/admin/production-stats")}
                    >
                      <AiOutlineBarChart style={{ marginRight: "-8px" }} />{" "}
                      Production Stats
                    </Nav.Link>
                  )}

                  {isAdmin && (
                    <Nav.Link
                      as={Link}
                      to="/admin/jiffy-reports"
                      active={pathname.startsWith("/admin/jiffy-reports")}
                    >
                      <AiOutlineBarChart style={{ marginRight: "8px" }} /> Jiffy
                      Reports
                    </Nav.Link>
                  )}

                  {isAdmin && (
                    <>
                      <Nav.Link
                        as={Link}
                        to="/admin/files"
                        active={pathname.startsWith("/admin/files")}
                      >
                        <AiOutlinePrinter style={{ marginRight: "8px" }} />{" "}
                        Admin Files
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        to="/admin/task-management"
                        active={pathname.startsWith("/admin/task-management")}
                      >
                        <AiOutlineCheckSquare style={{ marginRight: "8px" }} />
                        Task Management
                      </Nav.Link>

                      {userEmail === "mhmtmnctl20@gmail.com" && (
                        <>
                          <div className="mt-3 mb-1 ps-2 text-muted fw-bold">
                            Management
                          </div>

                          <Nav.Link
                            as={Link}
                            to="/admin/users"
                            active={pathname.startsWith("/admin-users")}
                            className="ps-4"
                          >
                            <AiOutlineSetting style={{ marginRight: "8px" }} />{" "}
                            Edit Users
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            to="/admin-orders"
                            active={pathname.startsWith("/admin-orders")}
                            className="ps-4"
                          >
                            <HiOutlineShoppingCart
                              style={{ marginRight: "8px" }}
                            />{" "}
                            Edit Orders
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            to="/admin/mockup-editor"
                            active={pathname.startsWith("/admin/mockup-editor")}
                            className="ps-4"
                          >
                            <AiOutlineSetting
                              style={{
                                marginRight: "6px",
                                verticalAlign: "middle",
                              }}
                            />{" "}
                            Mockups
                          </Nav.Link>
                        </>
                      )}

                      <Nav.Link
                        as={Link}
                        to="/admin/jiffy-orders"
                        active={pathname.startsWith("/admin/jiffy-orders")}
                      >
                        <AiOutlineMail style={{ marginRight: "4px" }} /> Jiffy
                        Orders
                      </Nav.Link>
                    </>
                  )}

                  {isAdmin && (
                    <Nav.Link
                      as={Link}
                      to="/admin/create-gangsheet"
                      active={pathname.startsWith("/admin/create-gangsheet")}
                    >
                      <AiOutlineSafetyCertificate
                        style={{ marginRight: "8px" }}
                      />{" "}
                      Create Gangsheet
                    </Nav.Link>
                  )}

                  <Nav.Link onClick={handleLogout}>
                    <FiLogOut style={{ marginRight: "8px" }} /> Logout
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </>
      </Container>
      <button
        className={`toggle-button ${sidebarLeft ? "active" : ""}`}
        onClick={handleSidebarToggle}
      >
        <div>
          <BiChevronLeft />
        </div>
      </button>
    </Navbar>
  );
};

export default Sidebar;
